import Log from '@app/libs/logger';
import type { AnalyticsConfig, Identity } from './types';
import type { AnalyticsEvent } from './events';

export function initAnalytics(_config: AnalyticsConfig): Promise<void> {
  // No-op: GTM is initialized by the existing Log.init pipeline via
  // GoogleAnalyticsMonitor (see src/App.tsx and src/infra/libs/logger/index.ts).
  // This function exists to keep the public API symmetrical with knox-canvas-flow.
  return Promise.resolve();
}

export function setIdentity(identity: Identity | null): void {
  if (!identity) {
    Log.setUserInfo(undefined, {});
    return;
  }
  Log.setUserInfo(identity.user_id, identity.client_name ? { client_name: identity.client_name } : {});
}

export function trackEvent(event: AnalyticsEvent): void {
  const { name, ...rest } = event;
  Log.event(name, { flow_type: 'Web App', event_source: 'Front End', ...rest }, true);
}
